/**
 * Blob をファイル名付きでダウンロードする。
 * presigned URL を直接 a[download] で開くとクロスオリジンでファイル名の指定が効かないため、
 * 取得したファイルを Blob 化してから保存する。
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const MAX_EXTENSION_LABEL_LENGTH = 4;

/** ファイル名から拡張子のラベル(大文字・最大4文字)を返す。拡張子がなければ FILE */
export const getFileExtensionLabel = (filename: string): string => {
  const index = filename.lastIndexOf('.');
  if (index <= 0 || index === filename.length - 1) {
    return 'FILE';
  }
  return filename.slice(index + 1, index + 1 + MAX_EXTENSION_LABEL_LENGTH).toUpperCase();
};
